import { LegalPage } from './legal-page'

const sections = [
  {
    heading: '1. Общие положения',
    body: [
      'Настоящая политика обработки персональных данных определяет порядок обработки и меры по обеспечению безопасности персональных данных пользователей сервисов Epic Growth.',
      'Оператор ставит своей целью соблюдение прав и свобод человека и гражданина при обработке персональных данных.',
      'Политика применяется к сайтам http://epicgrowth.io, https://my.epicgrowth.io, https://lk.epicgrowth.io и https://egconf.io.',
    ],
  },
  {
    heading: '2. Основные понятия и категории данных',
    body: [
      'Оператор может обрабатывать следующие данные: электронный адрес, фамилия и имя, номер телефона, сведения о профессии/квалификации, а также обезличенные технические данные (cookie и аналитика).',
      'Обработка включает сбор, запись, систематизацию, хранение, уточнение, использование, передачу в случаях, предусмотренных законом, блокирование и удаление данных.',
      'К обезличенным данным относятся технические параметры взаимодействия с сайтом, необходимые для аналитики и улучшения пользовательского опыта.',
    ],
  },
  {
    heading: '3. Цели обработки персональных данных',
    body: [
      'Цели обработки: предоставление доступа к сервисам, обратная связь, информирование о новых продуктах/событиях и улучшение качества сайта.',
      'Пользователь может отказаться от информационных сообщений и направить отзыв согласия на обработку персональных данных по контактам оператора.',
      'Оператор принимает правовые, организационные и технические меры для защиты персональных данных от неправомерного доступа и утраты.',
    ],
  },
  {
    heading: '4. Права пользователя и заключительные положения',
    body: [
      'Пользователь вправе запросить уточнение, ограничение обработки или удаление персональных данных в случаях, предусмотренных законодательством Российской Федерации.',
      'Запросы и уведомления по вопросам обработки персональных данных направляются на электронную почту: ap@epicgrowth.io.',
      'Политика действует бессрочно до замены новой редакцией. Актуальная версия публикуется в открытом доступе на ресурсах Epic Growth.',
      'Оператор вправе обновлять политику; изменения вступают в силу с момента публикации новой редакции, если иное не указано дополнительно.',
    ],
  },
]

export function PrivacyPolicyPage() {
  return (
    <LegalPage title="Политика в отношении обработки персональных данных" sections={sections} />
  )
}
